import nimActions from './nim/'
import nimState from './nimState/'
import nimMutations from './nimMutations/'

const nimSDK = {
  state: nimState,
  mutations: nimMutations,
  actions: nimActions
}

export default nimSDK



// WEBPACK FOOTER //
// ./src/store/modules/nimSDK.js